import { forwardRef } from 'react';

import { cx } from '../../utils/cx';
import { Text, type TextProps } from '../text/text';

import styles from './empty_state.module.css';

export type EmptyStateTextProps = TextProps;

/**
 * EmptyStateText - description sub-component for empty states.
 */
export const EmptyStateText = forwardRef<HTMLElement, EmptyStateTextProps>(
  (
    {
      className,
      elementType = 'p',
      color = 'medium_emphasis',
      children,
      ...rest
    },
    ref,
  ) => {
    return (
      <Text
        ref={ref}
        elementType={elementType}
        color={color}
        className={cx([styles.text, className])}
        {...rest}
      >
        {children}
      </Text>
    );
  },
);
